'use client';
export { HStack, Stack, VStack } from '@chakra-ui/react';

//# sourceMappingURL=index.js.map